import { copyTextToClipboard } from '@systemeio/ui'
import React from 'react'
import { Loader } from 'shared/components/loader'
import { useLocoTranslation } from 'shared/hooks/use-loco-translation'
import useUser from 'shared/hooks/use-user'
import { getLocaleForLink } from 'shared/utils/locale/get-locale-for-link'
import { LinkIcon } from '@systemeio/ui/icons'
import { formUrl } from 'shared/utils/links/form-url'

interface AffiliatePromotionLinkProps {
  affiliateId?: string
}

const AffiliateDashboardPromotionLink = ({ affiliateId }: AffiliatePromotionLinkProps) => {
  const { t } = useLocoTranslation()
  const { user } = useUser()

  const promotionLink =
    formUrl(`${getLocaleForLink(user?.dashboardLocale)}?sa=${affiliateId}`, false) ?? ''

  return (
    <div
      className={
        'border-text-secondary/30 bg-background-primary/50 flex max-w-full items-center rounded-lg border px-1.5 py-3'
      }
    >
      <button
        disabled={!affiliateId}
        onClick={async e => {
          e.preventDefault()
          await copyTextToClipboard(promotionLink, t('global.copy_clipboard'))
        }}
        className={
          'border-text-secondary/30 ring-brand-primary border-r px-3 py-1 outline-hidden ring-offset-1 focus-visible:ring-2'
        }
      >
        {affiliateId ? (
          <LinkIcon className="fill-brand-primary h-[15px] w-[15px] sm:h-[20px] sm:w-[20px]" />
        ) : (
          <Loader small />
        )}
      </button>
      {affiliateId && <span className={'text-brand-primary truncate px-3'}>{promotionLink}</span>}
    </div>
  )
}

export default AffiliateDashboardPromotionLink
